// Generated by GitHub Copilot
import { AssetDetailPanel } from '#components/domain/operations/assets/shared/detail/asset-detail-panel.tsx'
import { AssetEditDrawer } from '#components/domain/operations/assets/shared/edit/asset-edit.tsx'
import { WorkOrderCreateDrawer } from '#components/domain/operations/work-orders/shared/work-order-edit/work-order-create-drawer.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import type Asset from '#core/entities/operations/assets/Asset.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/assets/$assetId')({
  component: RouteComponent,
  staticData: {
    title: 'Asset Detail',
  },
})

function RouteComponent() {
  // Limited readers (any READ_LIMITED slot) may enter; the backend + limited-
  // access whitelists decide which properties they actually see.
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.ASSETS)} redirectOnNotAuthorized>
      <AssetDetailPageContent />
    </PermissionGuard>
  )
}

function AssetDetailPageContent() {
  const { companyId, assetId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('assets')

  const [editAsset, setEditAsset] = useState<Asset | null>(null)
  const [workOrderAsset, setWorkOrderAsset] = useState<Asset | null>(null)
  const [detailReloadKey, setDetailReloadKey] = useState(0)

  function handleBack() {
    void navigate({ to: '/$companyId/assets', params: { companyId } })
  }

  function handleEdit(asset: Asset) {
    setEditAsset(asset)
  }

  function handleEditClose() {
    setEditAsset(null)
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <AssetDetailPanel
              identifier={assetId}
              onClose={handleBack}
              onEdit={handleEdit}
              onUseInWorkOrder={setWorkOrderAsset}
              borderless
              reloadKey={detailReloadKey}
            />
          </div>
        </div>
      </div>

      <AssetEditDrawer
        isOpen={editAsset !== null}
        onClose={handleEditClose}
        asset={editAsset ?? undefined}
        onUpdated={() => { setEditAsset(null); setDetailReloadKey((k) => k + 1) }}
      />
      <WorkOrderCreateDrawer
        isOpen={workOrderAsset != null}
        initialAsset={workOrderAsset}
        onClose={() => setWorkOrderAsset(null)}
        onCreated={() => setWorkOrderAsset(null)}
      />
    </div>
  )
}
